var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4112 4.17426C14.9733 2.61214 17.5061 2.61216 19.0681 4.17432L19.8256 4.9318C21.3876 6.49391 21.3876 9.02655 19.8255 10.5886L11.2763 19.1376C10.7789 19.635 10.1591 19.9925 9.47939 20.1739L6.77676 20.8952C4.54805 21.49 2.50984 19.4519 3.10459 17.2231L3.82583 14.5204C4.00722 13.8407 4.36469 13.2208 4.86216 12.7233L13.4112 4.17426ZM17.6539 5.5885C16.8729 4.80743 15.6065 4.80741 14.8254 5.58847L13.9141 6.49985L17.4999 10.0857L18.4113 9.17439C19.1923 8.39335 19.1924 7.12704 18.4113 6.34598L17.6539 5.5885ZM7.91406 12.4998L12.4998 7.91406L16.0857 11.4999L11.4999 16.0857L7.91406 12.4998ZM6.49985 13.9141L6.27637 14.1375C6.02763 14.3863 5.8489 14.6962 5.7582 15.0361L5.03697 17.7388C4.83872 18.4817 5.51812 19.1611 6.26102 18.9628L8.96366 18.2415C9.30349 18.1508 9.6134 17.9721 9.86212 17.7234L10.0856 17.4999L6.49985 13.9141Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.f638bbac3c9c96a92fba117e781e28c6.svg";
export { ForwardRef as ReactComponent };